<template>
  <div>
    <EquipmentEditHeader
      v-if="isAdmin"
      data-cy="motor-search-view-edit-header"
    />
    <EquipmentTable
      data-cy="motor-search-view-table"
      @select="$emit('select', $event.data as Motors)"
    />
  </div>
</template>
<script setup lang="ts">
import { provide } from "vue";
import { useMotors } from "@/composables/equipment/motors/motors";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Motors } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Motors): void;
}>();

const motorSearch = useMotors(props.isAdmin);

provide("equipment", motorSearch);
</script>
